import React from "react";

const RequiredLabel = ({ label }: { label: React.ReactNode }) => (
  <React.Fragment>
    {label}
    <span className="text-danger ms-1" aria-hidden="true">
      *
    </span>
    <span className="visually-hidden"> (required)</span>
  </React.Fragment>
);

export default RequiredLabel;
